import { Icon } from "@react-gcc-eds/core";
import { DashboardTileAlignment } from "../reports/dashboard";
import { CustomTooltip } from "../reports/helpers/custom-tooltip";

export const DashboardTooltipHeader = ({
  header,
  tooltipInfo,
  alignment
}: {
  header: string;
  tooltipInfo?: string;
  alignment?: DashboardTileAlignment;
}) => {
  return (
    <div className="header-with-tooltip">
      <span>{header}</span>
      {tooltipInfo && (
        <CustomTooltip
          tooltip={tooltipInfo}
          position={alignment === DashboardTileAlignment.RIGHT ? "bottom-end" : "bottom"}
        >
          <Icon name="help" />
        </CustomTooltip>
      )}
    </div>
  );
};
